import { FormattedMessage } from 'react-intl';

import { useFlexiForwardSelector } from '@/App/tiles/FlexiForward/FlexiForwardContext.ts';
import { ClientWayAndRate } from '@/App/tiles/FlexiForward/FlexiForwardTile/FlexiForwardPriceSummary/Pricing/SolvingUpfrontPricing/ClientWayAndRate.tsx';
import { PriceDisplay } from '@/App/tiles/FlexiForward/FlexiForwardTile/FlexiForwardPriceSummary/Pricing/SolvingUpfrontPricing/PriceDisplay.tsx';
import {
  getCurrenciesFromCurrencyPair,
  getPremiumData,
  selectFlexiForwardRfsPremiumData,
} from '@/App/tiles/FlexiForward/utils.ts';
import { getFlexiForwardQuote } from '@/store/flexi-forward/helpers/rfs.ts';
import { useCurrencyPrecision } from '@/utils/currencies/useCurrencyPrecision.ts';

interface SolvingUpfrontPricingProps {
  isInternalSales: boolean;
}

export function SolvingUpfrontPricing({ isInternalSales }: SolvingUpfrontPricingProps) {
  const { currencyPair, currencies, isPremiumReceive } = useFlexiForwardSelector((flexiForward) => {
    const currencyPair = flexiForward.properties.currencyPair ?? '';
    const currencies = getCurrenciesFromCurrencyPair(currencyPair);

    const quote = getFlexiForwardQuote(flexiForward.properties.rfs);

    const premiumData = selectFlexiForwardRfsPremiumData(quote);
    const isUpfrontCurrency2 = flexiForward.properties.upfrontCurrency === currencies.currency2;
    const premiumCurrencyIndex = isUpfrontCurrency2 ? 2 : 1;
    const { premiumAmount } = getPremiumData(premiumData, premiumCurrencyIndex);

    return {
      currencyPair,
      currencies,
      isPremiumReceive: premiumAmount < 0,
    };
  });

  const precision = useCurrencyPrecision(currencyPair);

  return (
    <div className="d-flex flex-column justify-content-between h-100" data-e2e="solving-upfront-pricing">
      {/* PREMIUM WAY */}
      <div className="text-nowrap fs-12 line-height-1 mx-1">
        <FormattedMessage
          id={`flexiForwardTile.rates.streaming.AskAmount.${isPremiumReceive ? 'receive' : 'pay'}`}
          values={{ isInternalSales }}
        />
      </div>

      {/* PRICE */}
      <PriceDisplay currencies={currencies} precision={precision} isInternalSales={isInternalSales} />

      {/*CLIENT WAY & RATE */}
      <ClientWayAndRate currencies={currencies} precision={precision} isInternalSales={isInternalSales} />
    </div>
  );
}
